import React from 'react'

import TapsHappyHourPl1 from './template_updates/TapsHappyHourPl1'
import TapsHappyHourPl2 from './template_updates/TapsHappyHourPl2'
import TapsHappyHourPl3 from './template_updates/TapsHappyHourPl3'
import TapsHappyHourPl4 from './template_updates/TapsHappyHourPl4'
import TapsHappyHourPl5 from './template_updates/TapsHappyHourPl5'
import TapsHappyHourPl6 from './template_updates/TapsHappyHourPl6'
import TapsHappyHourPl7 from './template_updates/TapsHappyHourPl7'
import TapsHappyHourPl8 from './template_updates/TapsHappyHourPl8'
import TapsHappyHourPl9 from './template_updates/TapsHappyHourPl9'

const NewLocationRouter = (props) => {
    let location = props.locationShortId

    if (location === "pl1"){
        return (
            <TapsHappyHourPl1 
                tapMenu={props.tapMenu}
                happyHours={props.happyHours}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                filterStyle={props.filterStyle}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl2"){
        return (
            <TapsHappyHourPl2
                tapMenu={props.tapMenu}
                happyHours={props.happyHours}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                filterStyle={props.filterStyle}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl3"){
        return (
            <TapsHappyHourPl3
                tapMenu={props.tapMenu}
                happyHours={props.happyHours}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                filterStyle={props.filterStyle}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl4"){
        return (
            <TapsHappyHourPl4
                tapMenu={props.tapMenu}
                happyHours={props.happyHours}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                filterStyle={props.filterStyle}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl5"){
        return (
            <TapsHappyHourPl5
                tapMenu={props.tapMenu}
                happyHours={props.happyHours}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                filterStyle={props.filterStyle}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl6"){
        return (
            <TapsHappyHourPl6
            tapMenu={props.tapMenu}
            happyHours={props.happyHours}
            filterBrewery={props.filterBrewery}
            filterItem={props.filterItem}
            filterStyle={props.filterStyle}
            refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl7"){
        return (
            <TapsHappyHourPl7
            tapMenu={props.tapMenu}
            happyHours={props.happyHours}
            filterBrewery={props.filterBrewery}
            filterItem={props.filterItem}
            filterStyle={props.filterStyle}
            refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl8"){
        return (
            <TapsHappyHourPl8
            tapMenu={props.tapMenu}
            happyHours={props.happyHours}
            filterBrewery={props.filterBrewery}
            filterItem={props.filterItem}
            filterStyle={props.filterStyle}
            refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl9"){
        return (
            <TapsHappyHourPl9
            tapMenu={props.tapMenu}
            happyHours={props.happyHours}
            filterBrewery={props.filterBrewery}
            filterItem={props.filterItem}
            filterStyle={props.filterStyle}
            refactorAbv={props.refactorAbv}
            />
    )
        
    }
    
    else {
        return ("loading")
    }
}
export default NewLocationRouter